import { Box, Divider, SxProps, Theme, Typography } from "@mui/material";

type OverviewProps = {
  numsActiveUserYesterday?: number;
  numsOfRequestsYesterday?: number;
  numsActiveUsersSelectedPeriod?: number;
  numsOfRequestsSelectedPeriod?: number;
  sx?: SxProps<Theme>;
};

interface MetricItemProps {
  label: string;
  value: number | undefined;
}

const MetricItem = ({ label, value }: MetricItemProps) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      paddingY: "2rem",
      width: "100%",
    }}
  >
    <Typography
      sx={{
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "26px",
      }}
    >
      {label}
    </Typography>
    <Typography
      sx={{
        fontSize: "36px",
        fontWeight: "700",
        lineHeight: "26px",
        color: "#161447",
      }}
    >
      {value}
    </Typography>
  </Box>
);

export const Overview = (props: OverviewProps) => {
  const metrics = [
    {
      label: "Active users yesterday",
      value: props.numsActiveUserYesterday,
    },
    {
      label: "Number of requests yesterday",
      value: props.numsOfRequestsYesterday,
    },
    {
      label: "Active users during selected period",
      value: props.numsActiveUsersSelectedPeriod,
    },
    {
      label: "Number of requests during selected period",
      value: props.numsOfRequestsSelectedPeriod,
    },
  ];

  return (
    <Box
      sx={{
        borderRadius: "30px",
        background: (theme) => theme.palette.common.white,
        paddingX: "1.5rem",
        flexGrow: 1,
      }}
    >
      {metrics.map((metric, index) => (
        <>
          <MetricItem
            label={metric.label}
            value={metric.value}
            key={metric.label}
          />
          {index < metrics.length - 1 && (
            <Divider
              sx={{
                borderColor: "#E4F2F2",
                marginX: "-1.5rem",
              }}
            />
          )}
        </>
      ))}
    </Box>
  );
};
